module.exports = __webpack_public_path__ + "img/edit.f1dc4223.svg";